//Modules
import React from "react"
//Styles
import styled from "styled-components"
import { font, flex, spacing } from "../../Utilities"

const Album = ({ album }) => {
  const { albumTitle, images } = album.fields

  return (
    <StyledAlbum>
      <h2 className="album-title">{albumTitle}</h2>
      <div className="images-container">
        {images.map((image, i) => {
          const {
            description,
            file: { url },
          } = image.fields

          return (
            <div className="image-container">
              <img src={url} alt={description} className="image" />
            </div>
          )
        })}
      </div>
    </StyledAlbum>
  )
}

const StyledAlbum = styled.article`
  ${flex("column", "flex-start", "center")};

  .album-title {
    ${font("M")};
  }

  .images-container {
    ${flex("row", "center", "center")};
    flex-wrap: wrap;

    .image-container {
      height: 20rem;
      width: 37rem;
      margin: ${spacing.S};

      .image {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
`

export default Album
